/* @ngInject */
function DaysInColumnController ($scope, $translate, $timeout, $element) {
  $scope.dotColor = {
    backgroundColor: '#5E6E6E'
  }

  const api = {
    _changeDotColor
  }
  this.getApi = () => api

  activate()

  function activate () {
    $scope.tooltipText = $scope.daysInColumn === 1 ? $translate.instant('dayInColumn') : $translate.instant('daysInColumn')
    api._changeDotColor()

    $timeout(() => {
      jQuery($element).find('.kanban-card-popup.days-in-column-container').popup()
    }, 200, false)
  }

  function _changeDotColor () {
    if ($scope.daysInColumn > $scope.maxDays) {
      $scope.dotColor.backgroundColor = '#B8002A'
    } else if ($scope.daysInColumn === $scope.maxDays || $scope.daysInColumn === $scope.maxDays - 1) {
      $scope.dotColor.backgroundColor = '#D6A622'
    }
  }
}

export { DaysInColumnController }
